import React from 'react';
import { Navigation } from './components/Navigation';
import { HeroSection } from './components/HeroSection';
import { FramingBand } from './components/FramingBand';
import { ProblemSection } from './components/ProblemSection';
import { PlatformOverview } from './components/PlatformOverview';
import { OperatingModel } from './components/OperatingModel';
import { CapabilityDomains } from './components/CapabilityDomains';
import { HumanOpportunity } from './components/HumanOpportunity';
import { LifecycleArchitecture } from './components/LifecycleArchitecture';
import { Solutions } from './components/Solutions';
import { ProductEcosystem } from './components/ProductEcosystem';
import { GlobalArchitecture } from './components/GlobalArchitecture';
import { LeadershipReadiness } from './components/LeadershipReadiness';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-surface-bg font-body text-ink-dark selection:bg-teal selection:text-white" data-id="element-0">
      <Navigation data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <FramingBand data-id="element-4" />
        <ProblemSection data-id="element-5" />
        <PlatformOverview data-id="element-6" />
        <OperatingModel data-id="element-7" />
        <CapabilityDomains data-id="element-8" />
        <HumanOpportunity data-id="element-9" />
        <LifecycleArchitecture data-id="element-10" />
        <Solutions data-id="element-11" />
        <ProductEcosystem data-id="element-12" />
        <GlobalArchitecture data-id="element-13" />
        <LeadershipReadiness data-id="element-14" />
        <FAQ data-id="element-15" />
        <FinalCTA data-id="element-16" />
      </main>
      <Footer data-id="element-17" />
    </div>;
}